import {useDispatch} from "react-redux";

import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useSubscribeToNewsletter} from "../../newsletter/hooks/useSubscribeToNewsletter";
import {useAppSelector} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {useGetUserProfileQuery} from "../../user/api/get_user_profile";
import {UserPreferencesUpdateDataModal} from "../../user/components/preferences/UserPreferencesUpdateDataModal";
import {UserPhoneVerification} from "../../user/components/UserPhoneVerification";
import {UserUpdatePhoneNumberModal} from "../../user/components/UserUpdatePhoneNumberModal";
import {closeFlow, nextStep, RegistrationFlowStep} from "../state/registration_flow_slice";
import {AuthModalVariant} from "./auth_modal/AuthModalHeaderVariants";
import {RegistrationPreferencesModal} from "./registration_flow/RegistrationPreferencesModal";
import {AuthModalRegistrationFlow} from "./AuthModalRegistrationFlow";

export const RegistrationFlow = () => {
    const dispatch = useDispatch();
    const flowState = useAppSelector((state) => state.registrationFlow);
    const {hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();
    const {saveNewsletterSearchData, subscribeToNotifications} = useSubscribeToNewsletter();
    const {data: userProfile} = useGetUserProfileQuery();

    if (!flowState.isActive) {
        return null;
    }

    const handlers = {
        onNextStep: () => {
            dispatch(nextStep({hasCompleteProfile, hasPhoneVerified}));
        },
        onCloseFlow: () => {
            if (flowState.titleVariant === AuthModalVariant.NOTIFICATION_SUBSCRIPTION && userProfile) {
                subscribeToNotifications(userProfile);
            }
            dispatch(closeFlow());
        }
    };

    const onPreferencesSuccess = () => {
        if (flowState.titleVariant === AuthModalVariant.NOTIFICATION_SUBSCRIPTION && flowState.preferences) {
            const {regions, rooms, price} = flowState.preferences;
            saveNewsletterSearchData({
                ...(regions?.length ? {search: {regions}} : {}),
                ...(rooms ? {rooms} : {}),
                ...(price ? {price: {upper: price}} : {})
            });
        }

        if (flowState.userSource === UserSource.REGISTER_PROPERTY_PLAN) {
            handlers.onCloseFlow();
        } else {
            handlers.onNextStep();
        }
    };

    return (
        <>
            {flowState.currentStep === RegistrationFlowStep.REGISTRATION && <AuthModalRegistrationFlow />}
            {flowState.currentStep === RegistrationFlowStep.PHONE_COMPLETION && <UserUpdatePhoneNumberModal isOpen onSuccess={handlers.onNextStep} />}
            {flowState.currentStep === RegistrationFlowStep.PHONE_VERIFICATION && <UserPhoneVerification isOpen onSuccess={handlers.onNextStep} />}
            {flowState.currentStep === RegistrationFlowStep.PREFERENCES && (
                <RegistrationPreferencesModal
                    isOpen
                    isPropertyApplication={Boolean(flowState.propertyId)}
                    offerId={flowState.offerId}
                    onSuccess={onPreferencesSuccess}
                />
            )}
            {flowState.currentStep === RegistrationFlowStep.UPDATED_PREFERENCES && <UserPreferencesUpdateDataModal isOpen onClose={handlers.onCloseFlow} />}
        </>
    );
};
import {useDispatch} from "react-redux";

import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useSubscribeToNewsletter} from "../../newsletter/hooks/useSubscribeToNewsletter";
import {useAppSelector} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {useGetUserProfileQuery} from "../../user/api/get_user_profile";
import {UserPreferencesUpdateDataModal} from "../../user/components/preferences/UserPreferencesUpdateDataModal";
import {UserPhoneVerification} from "../../user/components/UserPhoneVerification";
import {UserUpdatePhoneNumberModal} from "../../user/components/UserUpdatePhoneNumberModal";
import {closeFlow, nextStep, RegistrationFlowStep} from "../state/registration_flow_slice";
import {AuthModalVariant} from "./auth_modal/AuthModalHeaderVariants";
import {RegistrationPreferencesModal} from "./registration_flow/RegistrationPreferencesModal";
import {AuthModalRegistrationFlow} from "./AuthModalRegistrationFlow";

export const RegistrationFlow = () => {
    const dispatch = useDispatch();
    const flowState = useAppSelector((state) => state.registrationFlow);
    const {hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();
    const {saveNewsletterSearchData, subscribeToNotifications} = useSubscribeToNewsletter();
    const {data: userProfile} = useGetUserProfileQuery();

    if (!flowState.isActive) {
        return null;
    }

    const handlers = {
        onNextStep: () => {
            dispatch(nextStep({hasCompleteProfile, hasPhoneVerified}));
        },
        onCloseFlow: () => {
            if (flowState.titleVariant === AuthModalVariant.NOTIFICATION_SUBSCRIPTION && userProfile) {
                subscribeToNotifications(userProfile);
            }
            dispatch(closeFlow());
        }
    };

    const onPreferencesSuccess = () => {
        if (flowState.titleVariant === AuthModalVariant.NOTIFICATION_SUBSCRIPTION && flowState.preferences) {
            const {regions, rooms, price} = flowState.preferences;
            saveNewsletterSearchData({
                ...(regions?.length ? {search: {regions}} : {}),
                ...(rooms ? {rooms} : {}),
                ...(price ? {price: {upper: price}} : {})
            });
        }

        if (flowState.userSource === UserSource.REGISTER_PROPERTY_PLAN) {
            handlers.onCloseFlow();
        } else {
            handlers.onNextStep();
        }
    };

    return (
        <>
            {flowState.currentStep === RegistrationFlowStep.REGISTRATION && <AuthModalRegistrationFlow />}
            {flowState.currentStep === RegistrationFlowStep.PHONE_COMPLETION && <UserUpdatePhoneNumberModal isOpen onSuccess={handlers.onNextStep} />}
            {flowState.currentStep === RegistrationFlowStep.PHONE_VERIFICATION && <UserPhoneVerification isOpen onSuccess={handlers.onNextStep} />}
            {flowState.currentStep === RegistrationFlowStep.PREFERENCES && (
                <RegistrationPreferencesModal
                    isOpen
                    isPropertyApplication={Boolean(flowState.propertyId)}
                    offerId={flowState.offerId}
                    onSuccess={onPreferencesSuccess}
                />
            )}
            {flowState.currentStep === RegistrationFlowStep.UPDATED_PREFERENCES && <UserPreferencesUpdateDataModal isOpen onClose={handlers.onCloseFlow} />}
        </>
    );
};
